// extracted by mini-css-extract-plugin
export var callCard = "_q3-0";
export var callMessageButton = "_q3-1";
export var helpIcon = "_q3-3";
export var helpIconContainer = "_q3-4";
export var verticalDivider = "_q3-2";